import CommonStyleEditor from "./CommonStyleEditor";

export default function IframeCellProperties({ cell, onChange }) {
    return (
        <div className="property-section">
            <div className="property-row">
                <div className="property-label">URL</div>
                <input className="property-input property-input-small" type="text" value={cell.url} onChange={(e) => onChange(cell.cell_id, {url: e.target.value, type: cell.type})}/>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    )
}